// extracted by mini-css-extract-plugin
export var brand = "_9h-9";
export var compact = "_9h-6";
export var extraSmall = "_9h-7";
export var icon = "_9h-0";
export var large = "_9h-4";
export var light = "_9h-1";
export var medium = "_9h-5";
export var outline = "_9h-b";
export var primaryDark = "_9h-a";
export var primaryLight = "_9h-8";
export var primaryModern = "_9h-c";
export var success = "_9h-2";
export var successSolid = "_9h-3";